import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import type { PublishPromptType } from 'app/atoms/ui';

import { Platform, Pressable, View } from 'react-native';
import type { NewScreenParams } from './index';
import { useNewListingPromptContent } from './use-new-listing-prompt-content';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconChevronLeft } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

interface NewListingPromptProps {
  state: [boolean | PublishPromptType, React.Dispatch<React.SetStateAction<boolean | PublishPromptType>>];
  newScreenParams?: NewScreenParams;
  onHoverIn?: () => void;
  onHoverOut?: () => void;
}
const NewListingPrompt = function NewListingPrompt({
  state,
  newScreenParams,
  onHoverIn,
  onHoverOut,
}: NewListingPromptProps) {
  const [isNewListingPromptVisible] = state;
  const { form } = useNewListingPromptContent({ state, newScreenParams });

  if (!isNewListingPromptVisible) {
    return null;
  }

  return (
    <Pressable
      onHoverIn={onHoverIn}
      onHoverOut={onHoverOut}
      style={{
        backgroundColor: theme.colors['surface.default'],
        paddingVertical: theme.spacing['spacing.general.x8'] - 6,
        paddingHorizontal: theme.spacing['spacing.general.x4'],
        position: 'absolute',
        width: 450,
        height: 'auto',
        top: 50,
        right: 0,
        zIndex: 1000,
        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
        borderRadius: 16,
      }}
    >
      {form ? (
        <>
          <Row alignItems="center">
            {form.onBack ? (
              <Pressable onPress={form.onBack}>
                <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} />
              </Pressable>
            ) : null}
            <Text fontWeight="700" style={{ flexGrow: 1 }} textAlign="center" variant="headerXSmall">
              {form.title}
            </Text>
            {form.onBack ? <View style={{ width: 30 }} /> : null}
          </Row>
          <Column
            gap="spacing.general.x2"
            marginBottom={Platform.OS === 'android' ? 'spacing.general.x5' : 'spacing.general.0'}
            marginTop="spacing.general.x4"
          >
            {form.buttons}
          </Column>
        </>
      ) : null}
    </Pressable>
  );
};

export { NewListingPrompt };
